import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	globalShortcuts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeDrawer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createIssue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keyboardShortcuts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keyboardShortcutsCommandPalette: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseAProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toggleSidebar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openHelpPanel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openCommandPalette: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSearchCommand: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	getHelp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createIssueIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseAProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	globalShortcuts: {
		id: 'keyboard-shortcuts.global-shortcuts',
		defaultMessage: 'Global shortcuts',
		description: '',
	},
	quickSearch: {
		id: 'keyboard-shortcuts.quick-search',
		defaultMessage: 'Quick search',
		description: '',
	},
	closeDrawer: {
		id: 'keyboard-shortcuts.close-drawer',
		defaultMessage: 'Close drawer',
		description: '',
	},
	createIssue: {
		id: 'keyboard-shortcuts.create-issue',
		defaultMessage: 'Create issue',
		description: '',
	},
	keyboardShortcuts: {
		id: 'keyboard-shortcuts.keyboard-shortcuts',
		defaultMessage: 'Keyboard shortcuts',
		description: '',
	},
	keyboardShortcutsCommandPalette: {
		id: 'keyboard-shortcuts.keyboard-shortcuts-command-palette',
		defaultMessage: 'View keyboard shortcuts',
		description:
			'Command in the command palette which triggers the modal that displays all keyboard shortcuts',
	},
	findIssues: {
		id: 'keyboard-shortcuts.find-issues',
		defaultMessage: 'Find issues',
		description: '',
	},
	browseAProject: {
		id: 'keyboard-shortcuts.browse-a-project',
		defaultMessage: 'Browse to a project',
		description: '',
	},
	toggleSidebar: {
		id: 'keyboard-shortcuts.toggle-sidebar',
		defaultMessage: 'Toggle sidebar',
		description: '',
	},
	openHelpPanel: {
		id: 'keyboard-shortcuts.open-help-panel',
		defaultMessage: 'Open help panel',
		description: 'Description of the keyboard shortcut to open the help-panel',
	},
	openCommandPalette: {
		id: 'keyboard-shortcuts.open-command-palette',
		defaultMessage: 'Open command palette',
		description: 'Description of the keyboard shortcut to open the command palette',
	},
	quickSearchCommand: {
		id: 'keyboard-shortcuts.quick-search-command',
		defaultMessage: 'Open quick search',
		description:
			'Command in the command palette that will trigger that will focus the user in the quick search input',
	},
	getHelp: {
		id: 'keyboard-shortcuts.get-help',
		defaultMessage: 'Get help',
		description: 'Command in the command palette that will trigger the help panel on the sidebar',
	},
	viewAllIssues: {
		id: 'keyboard-shortcuts.view-all-issues',
		defaultMessage: 'View all issues',
		description:
			'Command in the command palette that will navigate the user to the advanced issue search',
	},
	createIssueIssueTermRefresh: {
		id: 'keyboard-shortcuts.create-issue-issue-term-refresh',
		defaultMessage: 'Create work item',
		description: '',
	},
	findIssuesIssueTermRefresh: {
		id: 'keyboard-shortcuts.find-issues-issue-term-refresh',
		defaultMessage: 'Find work items',
		description: '',
	},
	viewAllIssuesIssueTermRefresh: {
		id: 'keyboard-shortcuts.view-all-issues-issue-term-refresh',
		defaultMessage: 'View all work items',
		description:
			'Command in the command palette that will navigate the user to the advanced issue search',
	},
	browseAProjectGalaxia: {
		id: 'keyboard-shortcuts.browse-a-project-galaxia',
		defaultMessage: 'Browse to a space',
		description: '',
	},
});
export default messages;
